import axios from 'axios'

import { ensureCsrfToken } from '../../../../lib/csrf'

const PROPOSALS_URL = '/api/digital-risk/capital-allocation-proposals/'

const proposalUrl = ({ proposalId, version }) =>
    `${PROPOSALS_URL}${encodeURIComponent(proposalId)}/versions/${encodeURIComponent(version)}/`

const mutationConfig = async () => ({
    withCredentials: true,
    headers: { 'X-CSRFToken': await ensureCsrfToken() }
})

export const createCapitalAllocationProposal = async (payload) => {
    const { data } = await axios.post(PROPOSALS_URL, payload, await mutationConfig())
    return data
}

export const fetchCapitalAllocationProposal = async ({ proposalId, version }) => {
    const { data } = await axios.get(proposalUrl({ proposalId, version }), {
        withCredentials: true
    })
    return data
}

export const updateCapitalAllocationProposal = async ({ proposalId, version, payload }) => {
    const { data } = await axios.patch(proposalUrl({ proposalId, version }), payload, await mutationConfig())
    return data
}

export const transitionCapitalAllocationProposal = async ({ proposalId, version, status }) => {
    const { data } = await axios.post(
        `${proposalUrl({ proposalId, version })}transition/`,
        { status },
        await mutationConfig()
    )
    return data
}

export const fetchCapitalAllocationProposalHistory = async ({ proposalId }) => {
    const { data } = await axios.get(`${PROPOSALS_URL}${encodeURIComponent(proposalId)}/versions/`, {
        withCredentials: true
    })
    return data
}

export const createCapitalAllocationProposalRevision = async ({ proposalId, version, revisionReason }) => {
    const { data } = await axios.post(
        `${proposalUrl({ proposalId, version })}revisions/`,
        { revision_reason: revisionReason },
        await mutationConfig()
    )
    return data
}
